var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "row py-4" }, [
      _c("div", { staticClass: "col-lg-6 offset-lg-3 col-12" }, [
        _c("div", { staticClass: "d-flex pb-4" }, [
          _c(
            "div",
            { staticClass: "flex-fill" },
            [
              _c(
                "router-link",
                { staticClass: "text-primary-link", attrs: { to: "/rewards" } },
                [_vm._v(_vm._s(_vm.$t("message.rewards.title")))]
              ),
              _vm._v(" "),
              _c("i", { staticClass: "fal fa-angle-right" }),
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("message.rewards.my_redeemed_rewards")) +
                  "\n        "
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "content" } }, [
          _c("nav", { staticClass: "nav nav-tabs nav-justified" }, [
            _c(
              "a",
              {
                staticClass: "nav-item nav-link",
                class: [_vm.currentTab === "isActive" ? "active" : ""],
                attrs: { href: "#active" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.showUserRewards("isActive")
                  }
                }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("message.rewards.tab_active_rewards")) +
                    "\n          "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "nav-item nav-link",
                class: [_vm.currentTab === "isUsed" ? "active" : ""],
                attrs: { href: "#used" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.showUserRewards("isUsed")
                  }
                }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("message.rewards.tab_used_rewards")) +
                    "\n          "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "nav-item nav-link",
                class: [_vm.currentTab === "isExpired" ? "active" : ""],
                attrs: { href: "#expired" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.showUserRewards("isExpired")
                  }
                }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("message.rewards.tab_expired_rewards")) +
                    "\n          "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tab-content", attrs: { id: "my-tab-content" } },
            [
              _c("user-rewards", {
                ref: "userRewards",
                attrs: { currentTab: _vm.currentTab }
              })
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bd45942a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd45942a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reward/UserRewardTab.vue
// module id = 2185
// module chunks = 0